export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    orderList: [
      {
        tableIdx: 1,
        orderIdx: 1,
        name: "홍길동",
        personnel: 5,
        menuArr: [
          {
            discount: 0,
            groupIdx: 5,
            menuIdx: 34,
            name: "메론 스무디",
            optionList: [],
            price: 6200,
            prodTotalDiscount: 0,
            prodTotalUprc: 6200,
            qty: 1,
          },
        ],
        receivedUprc: 0,
        startTime: "07:15",
        ordererIdx: 1,
      },
      {
        tableIdx: 3,
        orderIdx: 2,
        name: "고길동",
        personnel: 4,
        menuArr: [
          {
            discount: 0,
            groupIdx: 5,
            menuIdx: 35,
            name: "딸기 스무디",
            optionList: [],
            price: 5800,
            prodTotalDiscount: 0,
            prodTotalUprc: 5800,
            qty: 2,
          },
        ],
        receivedUprc: 0,
        startTime: "05:25",
        ordererIdx: 1,
      },
      {
        tableIdx: 7,
        orderIdx: 3,
        name: "조길동",
        personnel: 9,
        menuArr: [
          {
            discount: 0,
            groupIdx: 4,
            menuIdx: 28,
            name: "레드베리에이드",
            optionList: [],
            price: 5600,
            prodTotalDiscount: 0,
            prodTotalUprc: 5600,
            qty: 1,
          },
          {
            discount: 0,
            groupIdx: 4,
            menuIdx: 27,
            name: "오렌지에이드",
            optionList: [],
            price: 5400,
            prodTotalDiscount: 0,
            prodTotalUprc: 5400,
            qty: 1,
          },
        ],
        receivedUprc: 0,
        startTime: "08:45",
        ordererIdx: 1,
      },
    ],
  },
};
